export default "__VITE_ASSET__d5a82db3__"